import { Group, Text } from "@mantine/core";
import { Link } from "@remix-run/react";

import LaRucheLogo from "~/assets/misc/logo-icon.svg?react";
import { useTranslation } from "~/hooks/use-typed-translation";

import classes from "./partner-footer.module.scss";

export const PartnerFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className={classes.footer}>
      <div className={classes["footer-content"]}>
        <Group gap={"xs"} justify="space-between" w="100%" align="center">
          <Group gap={5}>
            <Text fz={13}>{t("support")}:&nbsp;+225 05 02 87 68 87</Text>•
            <Link to="mailto:engineering@laruche.health">
              engineering@laruche.health
            </Link>
          </Group>

          <Group gap={8} ml="auto">
            <Text span fz={13} fw={400} c="dimmed">
              {t("partner-of")}
            </Text>
            <Group gap={5}>
              <LaRucheLogo width={15} />
              <Text span fz={13} fw={500}>
                La Ruche Health
              </Text>
            </Group>
          </Group>
        </Group>
      </div>
    </footer>
  );
};
